import React from 'react';
import {Link} from 'react-router';
import PropTypes from 'prop-types';
import * as immutable from 'immutable';
import './TopicFormProfileUsage.styl';
import NewFilterWord from 'records/admin/topics/NewFilterWord';
import {usedProfiles} from 'components/admin/topics/common';

function sortedUsages(usages) {
  return usages.sort((l, r) => {
    // Departments by name
    const dept = cmp(l.department.name, r.department.name);
    if (dept !== 0) {
      return dept;
    }
    // Teams by name.
    if (l.team && r.team) {
      return cmp(l.team.name, r.team.name);
    }
    return 0;
  });
}

function cmp(a, b) {
  return a === b ? 0 : a < b ? -1 : 1;
}

/**
 * Given a topic, displays profiles associated with that topic, and the departments and teams using
 * that profile.
 */
export default class TopicFormProfileUsage extends React.PureComponent {
  static propTypes = {
    idToProfileMap: PropTypes.instanceOf(immutable.Map).isRequired,
    profileDepartmentAndTeamUsage: PropTypes.instanceOf(immutable.Map).isRequired,
    topic: PropTypes.instanceOf(NewFilterWord).isRequired,
  };

  render() {
    const {idToProfileMap, profileDepartmentAndTeamUsage, topic} = this.props;
    const profilesInOrder = usedProfiles(
      topic,
      idToProfileMap,
      profileDepartmentAndTeamUsage
    ).sortBy(profile => profile.name);

    return (
      <div className="topic-form-profile-usage">
        {profilesInOrder.size === 0 && <p>Not included in any topic profiles.</p>}
        {profilesInOrder.map(profile => (
          <div key={profile.filterWordProfileId} className="topic-form-profile-usage-profile">
            <header>{profile.name}</header>
            <div className="topic-form-used-by">
              <div>Used by:</div>
              {sortedUsages(profileDepartmentAndTeamUsage.get(profile.filterWordProfileId)).map(
                (usage, idx) => {
                  const to = {
                    pathname: '/admin/topics',
                    query: {
                      openDepartmentId: usage.department.id,
                    },
                  };
                  const link = (
                    <Link className="generic-link" to={to} onlyActiveOnIndex={false}>
                      {usage.department.name}
                    </Link>
                  );
                  if (usage.team) {
                    return (
                      <li key={idx}>
                        {link}, {usage.team.name}
                      </li>
                    );
                  } else {
                    return <li key={idx}>{link}</li>;
                  }
                }
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }
}
